import { createSelector } from 'reselect';

// Acesso ao estado base do slice
const selectHistoricoState = (state) => state.solicitacaoHistorico;

// Cria um selector memoizado por ID da solicitação
export const selectHistoricoBySolicitacaoId = (idSolicitacao) =>
  createSelector(
    [selectHistoricoState],
    (historicoState) =>
      historicoState.data.filter((h) => h.idSolicitacao === idSolicitacao)
  );
